<template>
  <div>
    <el-dialog
      v-model="isOpen"
      :title="`Detalhes do Cliente`"
      width="90%"
      :max-width="600"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="true"
      class="custom-dialog max-w-[900px]"
    >
      <slot />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};

const closeModal = () => {
  isOpen.value = false;
};

defineExpose({ openModal, closeModal });
</script>

<style></style>
